import React from 'react';

const Modal = ({ children, onClose, modalRef }) => {
	const handleOverlayClick = (event) => {
		if (event.target === event.currentTarget && onClose) {
			onClose();
		}
	};

	return (
		<div
			className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
			onClick={handleOverlayClick}
		>
			<div
				className="relative bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border rounded-2xl shadow-lg py-6 px-8 w-full max-w-4xl text-gray-800 dark:text-dark-text"
				style={{
					maxHeight: '90vh',
					overflowY: 'auto'
				}}
				ref={modalRef}
				onClick={(event) => event.stopPropagation()}
			>
				<button
					className="absolute top-2 right-2 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition duration-300"
					onClick={onClose}
				>
					<svg
						className="h-6 w-6 text-gray-600 dark:text-gray-300"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
				{children}
			</div>
		</div>
	);
};

export default Modal;
